function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import classNames from 'classnames';
import ImageWithPlaceholder from '@profile/src/Components/ImageWithPlaceHolder';
import styles from './styles.module.scss';
import { HeroStatus, NftItemRarity } from '@profile/src/utils/types';
import Spinner from '@profile/src/Components/Spinner';
import HeroTrophyIcon from '@profile/src/Components/HeroTrophy';
import HeroLevelIcon from '@profile/src/Components/HeroLevel';
import { webImageUri } from '@profile/src/utils/uri';
import icSelling from 'assets/svg/ic_selling.svg';
import icProcessing from 'assets/svg/ic_processing.svg';
import icForRent from 'assets/svg/ic_for_rent.svg';
import icRented from 'assets/svg/ic_rented.svg';
import icRentedOut from 'assets/svg/ic_rented_out.svg';
import icLocked from 'assets/svg/ic_lock_white_fill.svg';
import HeroClassIcon from '@profile/src/Components/HeroClass_V2';
import useParamsRoute from '@profile/src/hooks/useRouteParams';
import useCheckTradingEvent from '@profile/src/hooks/useCheckTradingEvent';
import { useTestId } from '@wolffun/testable-id';
const heroRarityStyleMap = {
  [NftItemRarity.COMMON]: styles.common,
  [NftItemRarity.EPIC]: styles.epic,
  [NftItemRarity.LEGENDARY]: styles.legendary
};
const ItemCard = /*#__PURE__*/React.forwardRef(({
  className,
  hero,
  onPress
}, ref) => {
  const {
    generateTestIdProps
  } = useTestId();
  const {
    own
  } = useParamsRoute();
  const isOwn = own === 'true';
  const {
    hasEvent: hasSpecialEvent,
    heroEvent
  } = useCheckTradingEvent({
    heroTrophyClass: hero.trophy,
    heroLevel: hero.level,
    heroClass: hero.heroRole,
    skinRarity: hero.skinRarity
  });
  const heroRarityClassName = heroRarityStyleMap[hero.rarity];

  const renderStatus = status => {
    switch (status) {
      case HeroStatus.AVAILABLE:
        return undefined;

      case HeroStatus.USER_NOT_MINT:
      case HeroStatus.NOT_MINT:
        return /*#__PURE__*/React.createElement("div", {
          className: styles.lock
        }, /*#__PURE__*/React.createElement("span", _extends({}, generateTestIdProps('hero-status'), {
          className: styles.span
        }), "NOT MINT"));

      case HeroStatus.DEFAULT:
        return undefined;

      case HeroStatus.HS_RENTED_RELEASED:
        return /*#__PURE__*/React.createElement("div", {
          className: styles.lock
        }, /*#__PURE__*/React.createElement("img", {
          className: styles.img,
          src: icLocked
        }), /*#__PURE__*/React.createElement("span", _extends({}, generateTestIdProps('hero-status'), {
          className: styles.span
        }), "LOCKED"));

      case HeroStatus.ON_MARKET:
        return /*#__PURE__*/React.createElement("div", {
          className: styles.status
        }, /*#__PURE__*/React.createElement("img", {
          className: styles.img,
          src: icSelling
        }), /*#__PURE__*/React.createElement("div", {
          className: styles.wrapText
        }, /*#__PURE__*/React.createElement("span", _extends({}, generateTestIdProps('hero-status'), {
          className: styles.span
        }), "Selling")));

      case HeroStatus.PREPARE_LENDING:
      case HeroStatus.PREPARE_SELLING:
      case HeroStatus.PREPARE_UNLOCKING:
      case HeroStatus.MINTING:
      case HeroStatus.USER_MINTING:
      case HeroStatus.IN_TRANSACTION_PROCESS:
        return /*#__PURE__*/React.createElement("div", {
          className: styles.status
        }, /*#__PURE__*/React.createElement("img", {
          className: styles.img,
          src: icProcessing
        }), /*#__PURE__*/React.createElement("div", {
          className: styles.wrapText
        }, /*#__PURE__*/React.createElement("span", _extends({}, generateTestIdProps('hero-status'), {
          className: styles.span
        }), "Processing")));

      case HeroStatus.IN_STAKING:
        return /*#__PURE__*/React.createElement("div", {
          className: styles.status
        }, /*#__PURE__*/React.createElement("img", {
          className: styles.img,
          src: icProcessing
        }), /*#__PURE__*/React.createElement("div", {
          className: styles.wrapText
        }, /*#__PURE__*/React.createElement("span", _extends({}, generateTestIdProps('hero-status'), {
          className: styles.span
        }), "Staking")));

      case HeroStatus.FOR_RENT:
        return /*#__PURE__*/React.createElement("div", {
          className: styles.status
        }, /*#__PURE__*/React.createElement("img", {
          className: styles.img,
          src: icForRent
        }), /*#__PURE__*/React.createElement("div", {
          className: styles.wrapText
        }, /*#__PURE__*/React.createElement("span", _extends({}, generateTestIdProps('hero-status'), {
          className: styles.span
        }), "For Rent")));

      case HeroStatus.RENTED:
        return /*#__PURE__*/React.createElement("div", {
          className: styles.status
        }, /*#__PURE__*/React.createElement("img", {
          className: styles.img,
          src: isOwn ? icRentedOut : icRented
        }), /*#__PURE__*/React.createElement("div", {
          className: styles.wrapText
        }, /*#__PURE__*/React.createElement("span", _extends({}, generateTestIdProps('hero-status'), {
          className: styles.span
        }), isOwn ? 'Rented Out' : 'Rented')));

      case HeroStatus.FUSING:
        return /*#__PURE__*/React.createElement("div", {
          className: styles.status
        }, /*#__PURE__*/React.createElement("img", {
          className: styles.img,
          src: icProcessing
        }), /*#__PURE__*/React.createElement("div", {
          className: styles.wrapText
        }, /*#__PURE__*/React.createElement("span", _extends({}, generateTestIdProps('hero-status'), {
          className: styles.span
        }), "Fusion")));

      default:
        return undefined;
    }
  };

  const renderTradingEvent = () => {
    if (hasSpecialEvent && heroEvent) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.specialEvent
      }, /*#__PURE__*/React.createElement("span", _extends({}, generateTestIdProps('hero-event'), {
        className: styles.txtTradingEvent
      }), "Hero Trading Event"));
    }

    return null;
  };

  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: classNames(className, styles.container),
    onClick: onPress
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.bgCard
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.shape, styles.background)
  })), /*#__PURE__*/React.createElement("div", _extends({}, generateTestIdProps('hero-item'), {
    className: styles.content
  }), /*#__PURE__*/React.createElement(ImageWithPlaceholder, {
    className: styles.portrait,
    src: webImageUri(hero.imageAvatar),
    renderPlaceholder: () => /*#__PURE__*/React.createElement(Spinner, {
      secondary: true,
      size: "50%",
      className: classNames(styles.portrait, hero.status !== HeroStatus.ON_MARKET && styles.spinner)
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.inner
  }, renderStatus(hero.status), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.itemInfo, heroRarityClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.wrapInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.line, heroRarityClassName)
  }), /*#__PURE__*/React.createElement("span", _extends({
    className: styles.name
  }, generateTestIdProps('hero-name')), hero.name.toUpperCase()), /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.tokenId, heroRarityClassName)
  }, hero.skinName))), renderTradingEvent(), /*#__PURE__*/React.createElement("div", {
    className: styles.heroLabel
  }, /*#__PURE__*/React.createElement(HeroTrophyIcon, {
    className: styles.trophy,
    small: true,
    value: hero.trophy
  }), /*#__PURE__*/React.createElement(HeroLevelIcon, {
    className: styles.heroLevel,
    small: true,
    value: hero.level
  }), /*#__PURE__*/React.createElement(HeroClassIcon, {
    small: true,
    value: hero.heroRole
  })))));
});
ItemCard.displayName = 'ItemCard';
export default ItemCard;